module.exports = __webpack_public_path__ + "img/DE05129.8e16d748.png";